import { render, staticRenderFns } from "./pantalla8.vue?vue&type=template&id=99019326&scoped=true&"
import script from "./pantalla8.vue?vue&type=script&lang=js&"
export * from "./pantalla8.vue?vue&type=script&lang=js&"
import style0 from "./pantalla8.vue?vue&type=style&index=0&id=99019326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99019326",
  null
  
)

export default component.exports